import { handleException} from "./handleException.js";

// https://cardguru.io/credit-card-generator/mir
export async function getCards() {
    try {
        const { data } = await new Promise((resolve) => {
            setTimeout(() => {
                // resolve({
                //     data: {
                //         cards: []
                //     }
                // })
                resolve(
                    {
                        data: {
                            cards: [
                                {
                                    "id": '5cefc31d-5359-402c-b59b-086df23b6189',
                                    "card_number": '5232572711504099 ',
                                    "issuer": 'mastercard',
                                    "exp": "10/2025",
                                    "cvv": 953,
                                    "holder": "Mohamed Ritchie",
                                    "address": "967 Willms Extension",
                                    "country": "Bahamas",
                                    "zipcode": "01771",
                                    "balance": 2570,
                                    "status": "exist",
                                    "frozen": false,
                                    "rules": {
                                        "currency": 'usd',
                                        "price": 10,
                                        "min_deposit": 10,
                                        "max_deposit": 100000,
                                    }
                                },
                                {
                                    "id": 'ac3324aa-8036-4cfb-9d58-f9ba560db931',
                                    "card_number": '4485334660675595',
                                    "issuer": 'visa',
                                    "exp": "05/2028",
                                    "cvv": 516,
                                    "holder": "Heath Gutmann",
                                    "address": "56575 King River",
                                    "country": "Bosnia and Herzegovina",
                                    "zipcode": "45150",
                                    "status": "processed",
                                    "rules": {
                                        "currency": 'eur',
                                        "price": 10,
                                        "min_deposit": 10,
                                        "max_deposit": 100000,
                                    }
                                },
                                {
                                    "id": '89d32e51-2024-4098-8ad8-bf131078ded0',
                                    "card_number": '4716153491210203',
                                    "issuer": 'visa',
                                    "exp": "07/2027",
                                    "cvv": 856,
                                    "holder": "Bradley Halvorson",
                                    "address": "4076 Bauch Walk",
                                    "country": "Moldova",
                                    "zipcode": "60555",
                                    "balance": 3270,
                                    "status": "exist",
                                    "rules": {
                                        "currency": 'eur',
                                        "price": 10,
                                        "min_deposit": 10,
                                        "max_deposit": 100000,
                                    }
                                },
                                {
                                    "id": '8ef976bf-b6e4-41f2-bc5f-4c927f898c8f',
                                    "card_number": '5212572711504055',
                                    "issuer": 'mastercard',
                                    "exp": "12/2028",
                                    "cvv": 558,
                                    "holder": "Ellie Auer",
                                    "address": "7848 Feil Roads",
                                    "country": "Equatorial Guinea",
                                    "zipcode": "78836-4689",
                                    "balance": 1120,
                                    "status": "exist",
                                    "rules": {
                                        "currency": 'eur',
                                        "price": 10,
                                        "min_deposit": 10,
                                        "max_deposit": 100000,
                                    }
                                },
                                {
                                    "id": '44eb5f0d-1d61-46cd-a3f4-0e98f6de87d0',
                                    "card_number": '4916732366634593',
                                    "issuer": 'visa',
                                    "exp": "03/2029",
                                    "cvv": 458,
                                    "holder": "Armand Bednar",
                                    "address": "32477 Kirsten Gardens",
                                    "country": "Sudan",
                                    "zipcode": "03508-1412",
                                    "balance": 32570,
                                    "status": "exist",
                                    "rules": {
                                        "currency": 'eur',
                                        "price": 10,
                                        "min_deposit": 10,
                                        "max_deposit": 100000,
                                    },
                                    "frozen": true
                                },
                                {
                                    "id": '5cefc31d-5359-402c-b59b-086df23b6181',
                                    "card_number": '5371652456138120 ',
                                    "issuer": 'mastercard',
                                    "exp": "01/2026",
                                    "cvv": 533,
                                    "holder": "Timmy Swaniawski",
                                    "address": "777 Brionna Mount",
                                    "country": "Colombia",
                                    "zipcode": "38760-8371",
                                    "balance": 2570,
                                    "status": "processed",
                                    "rules": {
                                        "currency": 'eur',
                                        "price": 10,
                                        "min_deposit": 10,
                                        "max_deposit": 100000,
                                    }
                                },
                                {
                                    "id": '44eb5f0d-1d61-46cd-a3f4-0e98f6de87d5',
                                    "card_number": '4556888079502025',
                                    "issuer": 'visa',
                                    "exp": "02/2028",
                                    "cvv": 122,
                                    "holder": "Janelle Yundt",
                                    "address": "28683 Vinnie Pike",
                                    "country": "Afghanistan",
                                    "zipcode": "79743",
                                    "balance": 32570,
                                    "status": "exist",
                                    "rules": {
                                        "currency": 'eur',
                                        "price": 10,
                                        "min_deposit": 10,
                                        "max_deposit": 100000,
                                    }
                                }
                            ]
                        },
                    }
                )
            }, 1500);
        })

        return data.cards
    } catch (error) {
        handleException(error)
        return {}
    }
}

export async function getCurrencies() {
    try {
        const { data } = await new Promise((resolve) => {
            setTimeout(() => {
                resolve(
                    {
                        data: {
                            currencies: [
                                {
                                    "id": '5cefc31d-5359-402c-b59b-086df23b6189',
                                    "value": 'USD',
                                    "symbol": "$",
                                    "issuers": ["visa", "mastercard"]
                                },
                                {
                                    "id": 'ac3324aa-8036-4cfb-9d58-f9ba560db931',
                                    "value": 'EUR',
                                    "symbol": "€",
                                    "issuers": ["visa", "mastercard"]
                                },
                                {
                                    "id": '89d32e51-2024-4098-8ad8-bf131078ded0',
                                    "value": 'RUB',
                                    "symbol": "₽",
                                    "issuers": ["visa", "mastercard"]
                                }
                            ]
                        },
                    }
                )
            }, 200);
        })

        return data.currencies
    } catch (error) {
        handleException(error)
        return {}
    }
}